export const PIPELINE_UPDATE = 'PIPELINE_UPDATE';
export const PIPELINE_CARD_UPDATE = 'PIPELINE_CARD_UPDATE';
export const PIPELINE_CARD_ADD = 'PIPELINE_CARD_ADD';
export const CHANGE_PIPELINE_STATE = 'CHANGE_PIPELINE_STATE';
